import { render, staticRenderFns } from "./EscolherOrgaoDominio.vue?vue&type=template&id=e5f9f122&scoped=true"
import script from "./EscolherOrgaoDominio.vue?vue&type=script&lang=js"
export * from "./EscolherOrgaoDominio.vue?vue&type=script&lang=js"
import style0 from "./EscolherOrgaoDominio.vue?vue&type=style&index=0&id=e5f9f122&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f9f122",
  null
  
)

export default component.exports